import api from "../middlware/api";
import { BASE_URL } from "../constants";

export const getStockLocations = (params?: Record<string, any>) => {
  return new Promise((resolve, reject) => {
    const query = new URLSearchParams();
    if (params) {
      for (const key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, String(params[key]));
        }
      }
    }
    const qs = query.toString();
    api
      .get(qs ? `${BASE_URL}/api/v1/stock-locations?${qs}` : `${BASE_URL}/api/v1/stock-locations`)
      .then((res) => resolve(res.data))
      .catch(reject);
  });
};

export const getStockLocationById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/stock-locations/${id}`)
      .then((res) => resolve(res.data))
      .catch(reject);
  });
};

export const createStockLocation = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/stock-locations`, payload)
      .then((res) => resolve(res.data))
      .catch(reject);
  });
};

export const updateStockLocation = (id: number, payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/stock-locations/${id}`, payload)
      .then((res) => resolve(res.data))
      .catch(reject);
  });
};
